var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMizarTypo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 54,
    viewBox: "0 0 200 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3125_17545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.762 13.2869H88.702L78.7849 33.4975L68.8394 13.2869H61.8142V39.9258H66.9168V19.1671L76.8877 39.9258H80.4636L90.3965 19.2081L90.4218 39.9258H95.762V13.2869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.799 13.2869V39.9258H107.165V13.3184L101.799 13.2869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.571 13.2869L112.948 13.3184V17.8412H130.527L112.948 35.6077V39.9258H137.571V35.3715H120.059L137.578 17.8601L137.571 13.2869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.034 39.9257L158.998 13.3184H152.569L140.533 39.9257H145.787L148.191 34.4802H163.202L165.789 39.9257H171.034ZM161.079 29.9228H150.25L155.666 18.0805L161.079 29.9228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.003 39.9257L192.769 30.5149H192.715C196.906 30.5149 199.031 28.452 199.031 24.3828V19.3057C199.031 17.29 198.499 15.7625 197.447 14.7735C196.396 13.7845 194.812 13.2869 192.715 13.2869H173.686V39.9257H179.07L179.038 30.6629H186.434L194.071 39.9257H199.994H200.003ZM190.406 26.1433H179.048V17.8412H190.406C190.996 17.8308 191.585 17.873 192.167 17.9671C192.513 18.0085 192.841 18.1412 193.117 18.3514C193.333 18.5429 193.476 18.8018 193.523 19.0852C193.615 19.5615 193.656 20.046 193.646 20.5309V23.4568C193.656 23.9416 193.615 24.4262 193.523 24.9024C193.474 25.1854 193.331 25.4438 193.117 25.6363C192.84 25.8458 192.512 25.9784 192.167 26.0205C191.585 26.1123 190.996 26.1534 190.406 26.1433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2706 2.10291L44.9544 14.5499V39.4502L23.2706 51.8972L1.58685 39.4502V14.5499L23.2706 2.10291ZM23.2706 0.282471L22.4788 0.736005L0.791841 13.1862L0 13.6397V40.3604L0.791841 40.8139L22.4788 53.2641L23.2706 53.7176L24.0625 53.2641L45.7462 40.8139L46.5412 40.3604V13.6397L45.7462 13.1862L24.0625 0.736005L23.2706 0.282471Z",
    fill: "url(#paint0_linear_3125_17545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2705 6.25085L8.8147 14.5499L23.2705 22.8521L37.7264 14.5499L23.2705 6.25085Z",
    fill: "url(#paint1_linear_3125_17545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19775 16.6254L23.2707 27L41.3405 16.6254V37.3746L37.7266 39.4502V22.8521L23.2707 31.1511L8.81488 22.8521V39.4502L5.19775 37.3746V16.6254Z",
    fill: "url(#paint2_linear_3125_17545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8147 39.4502L16.0426 35.2991V27.0001L8.8147 22.8521V39.4502Z",
    fill: "url(#paint3_linear_3125_17545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7264 22.8521V39.4502L30.4985 35.2991V27.0001L37.7264 22.8521Z",
    fill: "url(#paint4_linear_3125_17545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2706 47.7492L34.1125 41.5226L23.2706 35.2991L12.4287 41.5226L23.2706 47.7492Z",
    fill: "url(#paint5_linear_3125_17545)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3125_17545",
    x1: 23.3498,
    y1: 57.1034,
    x2: 23.1869,
    y2: -5.28592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1B2468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22418A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#275BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2B6FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2F7FD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#318ADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3390E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3392E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3392E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#3392E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3125_17545",
    x1: 23.2705,
    y1: 6.89021,
    x2: 23.2705,
    y2: 21.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3392E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3697E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3FA4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#4EBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#63D9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CFFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3125_17545",
    x1: 5.11224,
    y1: 27.8032,
    x2: 40.6152,
    y2: 28.2268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3392E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4BB6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#61D6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#70EDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#79FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7CFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7AFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#73F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#67DFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#56C6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#41A7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3392E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3125_17545",
    x1: 12.4635,
    y1: 39.447,
    x2: 12.3727,
    y2: 23.4442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3392E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#328FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3086DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2D77C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2962B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#234690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1C2569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1E61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3125_17545",
    x1: 34.1125,
    y1: 23.186,
    x2: 34.1125,
    y2: 38.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#1C2569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#234690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2962B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#2D77C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3086DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#328FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3392E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3125_17545",
    x1: 23.2168,
    y1: 47.598,
    x2: 23.3232,
    y2: 35.2865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3392E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#328DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#2F80D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2A69B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#234A94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1B2266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1E61"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3125_17545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 53.4351,
    fill: "white",
    transform: "translate(0 0.282471)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMizarTypo);
export default __webpack_public_path__ + "static/media/mizar-typo.81e489866c8cc6e74ab6bc80ad391b83.svg";
export { ForwardRef as ReactComponent };